<router-outlet></router-outlet>

<!-- Loading Overlay for Cold Start Authentication -->
@if (isAuthenticating) {
  <div class="auth-loading-overlay">
    <div class="spinner-container">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
  </div>
}

<!-- Mobile cold-start offline/retry screen: shown when token refresh failed but the refresh
     token is still valid, instead of dropping the user on the login page. Auto-recovers on reconnect. -->
@if (authOfflineRetry) {
  <div class="auth-offline-overlay">
    <div class="auth-offline-content">
      <i class="icon-warning icon-orange auth-offline-icon"></i>
      <h2 class="auth-offline-title">Can't reach the network</h2>
      <p class="auth-offline-text">Check your connection — we'll reconnect automatically when you're back online.</p>
      <button type="button" class="btn btn-secondary btn-secondary auth-offline-retry-btn" (click)="retryColdStartAuth()">
        <i class="icon-refresh icon-white"></i> Retry
      </button>
      <p class="auth-offline-signin-text">
        Connected but still seeing this?
        <button type="button" class="btn btn-link auth-offline-signin-btn" [disabled]="isSigningInAgain" (click)="signInAgain()">Sign in again</button>
      </p>
    </div>
  </div>
}

<!-- Mobile cold-start session-expired screen: shown when Okta rejected the stored sign-in, so Retry
     can't help. Sign in again clears the dead session and goes to the login page. -->
@if (authSessionExpired) {
  <div class="auth-offline-overlay">
    <div class="auth-offline-content">
      <i class="icon-warning icon-orange auth-offline-icon"></i>
      <h2 class="auth-offline-title">Your sign-in has expired</h2>
      <p class="auth-offline-text">Please sign in again to continue.</p>
      <button type="button" class="btn btn-secondary auth-offline-retry-btn" [disabled]="isSigningInAgain" (click)="signInAgain()">
        Sign in again
      </button>
    </div>
  </div>
}

<!-- Demo Mode Indicator -->
@if (isDemoMode) {
  <div class="demo-mode-indicator">
    <i class="icon-flask"></i> DEMO MODE - Using Staging Environment
  </div>
}

<!-- Bottom Sheet Container -->
<div #bottomSheetContainer></div>

<!-- AI Chat Widget Container - Lazy loaded -->
<div #aiWidgetContainer></div>

<!-- Cache Debug Panel (Development Only) -->
<!-- <app-cache-debug></app-cache-debug> -->

<!-- Hidden component for i18n extraction - never actually renders -->
<i18n-constants style="display:none"></i18n-constants>
